import { render, staticRenderFns } from "./WattInfo.vue?vue&type=template&id=f45065cc&scoped=true"
import script from "./WattInfo.vue?vue&type=script&lang=js"
export * from "./WattInfo.vue?vue&type=script&lang=js"
import style0 from "./WattInfo.vue?vue&type=style&index=0&id=f45065cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45065cc",
  null
  
)

export default component.exports